import { render } from "./RefTopPopUp.vue?vue&type=template&id=eb4812fc"
import script from "./RefTopPopUp.vue?vue&type=script&lang=js"
export * from "./RefTopPopUp.vue?vue&type=script&lang=js"

import "./RefTopPopUp.vue?vue&type=style&index=0&id=eb4812fc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__